import AxiosInstance from "./AxiosInstance";

// Get All Destinations
export const getAllClientTestimonial = async () => {
  try {
    const { data } = await AxiosInstance.get("/client_testimonial");
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Create Destination
export const createClientTestimonial = async (clientTestimonial) => {
  try {
    const { data } = await AxiosInstance.post(
      "/client_testimonial",
      clientTestimonial
    );
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Update Destination
export const updateClientTestimonial = async (clientTestimonial) => {
  try {
    const { data } = await AxiosInstance.put(
      "/client_testimonial",
      clientTestimonial
    );
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Delete Destination
export const deleteClientTestimonial = async (clientTestimonial) => {
  try {
    const { data } = await AxiosInstance.delete(
      `/client_testimonial/${clientTestimonial._id}`
    );
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
